module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "ContentsPage"
  }, [_c('h1', [_vm._v("Contents")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/Text/Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/Text/Introduction"
    }
  }, [_vm._v("Introduction: Preaching the Bible way")])]), _vm._v(" "), _c('ol', [_c('li', [_c('a', {
    attrs: {
      "href": "#/Text/Chapter1"
    }
  }, [_vm._v("Jesus Christ, the preacher")]), _vm._v(": Setting the supreme standard")]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tim Keller")]), _vm._v(": Be aware of cultural and philosophical challenges to the gospel")]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Piper")]), _vm._v(": Inspire a passion for the glory of God")]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vaughan Roberts")]), _vm._v(": Let the Bible speak with simplicity and freshness")]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simon Ponsonby")]), _vm._v(": Be a Word-and-Spirit preacher")]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J.John")]), _vm._v(": Use humour and story to connect and engage, and dismantle barriers")]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("David Cook")]), _vm._v(": Create interest; apply well")]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Ortberg")]), _vm._v(": Preach with spiritual formation in mind")]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nicky Gumbel")]), _vm._v(": Make much of Jesus Christ")]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rico Tice")]), _vm._v(": Preach with urgency and evangelistic zeal")]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alistair Begg")]), _vm._v(": Persuade people by passionate argument from the Bible")]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mark Driscoll")]), _vm._v(": Teach with directness, challenge and relevance")]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mark Dever")]), _vm._v(": Expose all of God’s Word to all of God’s people")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/Text/Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: Preaching that changes lives")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/Text/Appendix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: The survey and online resources")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/Text/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa8cef8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Contents.vue
// module id = 66
// module chunks = 0